import { lazy } from 'react';

// Types
import { ClickAndCollectChargesTooltipProps as LazyComponentProps } from './ClickAndCollectChargesTooltip.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "clickAndCollectChargesTooltip" */ './ClickAndCollectChargesTooltip')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'ClickAndCollectChargesTooltip');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as ClickAndCollectChargesTooltip };
